export default __webpack_public_path__ + "static/kaluga-9bb01e73f580ebbe0305493c90573349.webp";